module.exports = __webpack_public_path__ + "static/media/distrame9.651def2b.webp";